<script lang="ts">
  import clsx from 'clsx'
  import { getProgressBarContext } from '../progressBarContext'
  import { formatSecondsToDigitDisplay } from '../../../../utils/Time'
  import videoStore from '../../../../stores/video.svelte'
  import { COLORS } from '../../../../const/themes'

  type Props = {
    backgroundParts: {
      start: number
      end: number
      left: number
      width: number
      text: string
    }[]
  }

  let { backgroundParts }: Props = $props()

  const progressBarContext = getProgressBarContext()
</script>

{#each backgroundParts as part}
  <div
    class={clsx(
      'absolute top-0 h-full hover:bg-red duration-200 ease-linear',
      backgroundParts?.length > 1 &&
        progressBarContext.hoverTime &&
        (videoStore.state.mouseOver || !videoStore.state.isPlaying) &&
        videoStore.state.hasPlaybackStarted &&
        part.start <= progressBarContext.hoverTime &&
        progressBarContext.hoverTime <= part.end &&
        'h-[8px] top-[-5px]',
    )}
    style={`left: ${part.left}%; width: ${part.width}%; opacity: 0.5; background-color: ${COLORS.MEDIUM}`}
  ></div>
  {#if backgroundParts?.length > 1 && progressBarContext.hoverTime && (videoStore.state.mouseOver || !videoStore.state.isPlaying) && videoStore.state.hasPlaybackStarted && part.start <= progressBarContext.hoverTime && progressBarContext.hoverTime <= part.end}
    <div
      class="text-white absolute top-[-30px] left-0 text-xs bg-black/30 w-fit p-1 rounded-sm"
      style="left: {part.left}%;"
    >
      {formatSecondsToDigitDisplay(progressBarContext.hoverTime)} - {part.text}
    </div>
  {/if}
{/each}
